import React from "react";
import { AlertTriangle } from "lucide-react"; 

export default function MessagePage({ 
  title = "Service Unavailable 🚫", 
  message = "This service is temporarily not available. Please contact Fusion support.", 
}) {
  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100 px-4">
      <div className="bg-white rounded-2xl shadow-lg p-8 max-w-md text-center">
        <div className="flex justify-center mb-4">
          <AlertTriangle size={58} className="text-red-500" />
        </div>
        <h1 className="text-2xl font-bold mb-2">{title}</h1>
        <p className="text-gray-600 mb-6">{message}</p>
        <br/>
       
      </div>
    </div>
  );
}
